import { render, staticRenderFns } from "./lang-content.vue?vue&type=template&id=567bd936&scoped=true&"
import script from "./lang-content.vue?vue&type=script&lang=js&"
export * from "./lang-content.vue?vue&type=script&lang=js&"
import style0 from "./lang-content.vue?vue&type=style&index=0&id=567bd936&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567bd936",
  null
  
)

export default component.exports